import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.#applyStoredLayout();

    this.setAttribute('initialized', '');
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * 
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;

    grid.setAttribute('product-grid-view', value);

    const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
    const inputName = viewport === 'desktop' ? 'grid' : 'grid-mobile';
    const inputs = this.querySelectorAll(`input[name="${inputName}"]`);

    inputs.forEach((input) => {
      input.checked = input.value === value;
    });
  }
  /**
   * Syncs the grid controls and grid attribute to the stored layout for the current viewport.
   */
  #applyStoredLayout = () => {
    const { grid } = this.refs;
    if (!grid) return;

    const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
    const storageKey = `product-grid-view-${viewport}`;

    const stored = sessionStorage.getItem(storageKey) || 'default';

    grid.setAttribute('product-grid-view', stored);

    const inputName = viewport === 'desktop' ? 'grid' : 'grid-mobile';
    const inputs = this.querySelectorAll(`input[name="${inputName}"]`);
    if (!inputs.length) return;

    inputs.forEach((input) => {
      input.checked = input.value === stored;
    });
  };

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
    #handleMediaQueryChange = () => {
    this.#applyStoredLayout();
  };

}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
